<template>
  <div class="accordion-item">
    <div class="accordion-item-content">
      <div class="profilepicture">
        <!-- Replace div with img-->
      </div>
      <div class="organization-location">
        <span class="organization">{{item.organization}}</span>
        <span class="location">{{item.city}}</span>
      </div>

      <div class="downArrow">
        <i class="fa fa-chevron-down" :class="{ rotate: active  }"></i>
      </div>
    </div>
    <div :id="itemId" class="description-container">
      <div class="description-content">
        <b-container fluid>
          <b-row>
            <b-col>
              <h2>
                If you are able to complete this delivery
                <span>within 1-2 days</span>, fill out this form.
              </h2>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <h3>CAA Rep</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col md>
              <label>First Name</label>
              <input placeholder="First Name" class="name" />
            </b-col>
            <b-col md>
              <label>Last Name</label>
              <input placeholder="Last Name" class="name" />
            </b-col>
            <b-col md>
              <label>Email</label>
              <input placeholder="Email" class="email" />
            </b-col>
            <b-col md>
              <label>Phone Number</label>
              <input placeholder="Phone Number" class="phone" />
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <h3>PPE to be picked up</h3>
            </b-col>
          </b-row>
          <b-row class="big-push">
            <b-col md>
              <b-row>
                <b-col md>
                  <h4>20</h4>
                  <span class="subtitle">Masks</span>
                </b-col>
                <b-col md>
                  <h4>20</h4>
                  <span class="subtitle">Caps</span>
                </b-col>
                <b-col md>
                  <h4>20</h4>
                  <span class="subtitle">Other</span>
                </b-col>
              </b-row>
            </b-col>
            <b-col md>
              <b-row>
                <b-col md>
                  <span class="subtitle">Additional Notes</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md>Other: face shields</b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row>
            <b-col md>
              <b-row>
                <b-col md>
                  <h3>PPE Pick-up Address</h3>
                </b-col>
              </b-row>

              <b-row>
                <b-col md>
                  <p>Pick-up Contact</p>
                  <p>
                    <strong>Michael Chan</strong>
                  </p>
                  <p>Mike@channel1media.com</p>
                  <p>(416) 526-5264</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col md>
                  <p>Closest major city centre: Toronto</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col md>
                  <p>29 Atlantic Avenue</p>
                  <p>Suite 100</p>
                  <p>Toronto, ON M6K 3E7</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col md>
                  <p>Pick-up Notes:</p>
                  <p>Back door</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col md>
              <b-row>
                <b-col md>
                  <h3>PPE Delivery Address</h3>
                </b-col>
              </b-row>

              <b-row>
                <b-col md>
                  <p>Pick-up Contact</p>
                  <p>
                    <strong>Michael Chan</strong>
                  </p>
                  <p>Mike@channel1media.com</p>
                  <p>(416) 526-5264</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col md>
                  <p>Closest major city centre: Toronto</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col md>
                  <p>29 Atlantic Avenue</p>
                  <p>Suite 100</p>
                  <p>Toronto, ON M6K 3E7</p>
                </b-col>
              </b-row>

              <b-row>
                <b-col md>
                  <p>Delivery Notes:</p>
                  <p>Back door</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="right-align submit">
            <b-col>
              <button class="red button-2">Cancel</button>
              <button class="green">Complete Delivery</button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccordionItem",
  props: {
    item: {
      type: Object,
      required: true
    },
    itemId: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.accordion-item {
  color: black !important;
  overflow: hidden;
  margin-bottom: 10px;
  width: 100%;
  max-width: 100%;
  .accordion-item-content {
    cursor: pointer;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 20px;
    background: #eeeeee;
    span {
      font-family: "Brown-Bold";
      font-size: 15px;
      line-height: 15px;
      text-transform: uppercase;
      color: #000;
    }
    .profilepicture {
      height: 23px;
      width: 23px;
      border-radius: 50%;
      background: linear-gradient(to right, #20356d, #d83cb4);
      float: left;
      @media (max-width: $md) {
        display: none;
      }
    }
    .organization-location {
      display: flex;
      flex-direction: column;
      .organization {
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
        margin-left: 7px;
        @media (max-width: $sm) {
          margin-left: 0;
        }
      }
      .location {
        opacity: 0.7;
        font-size: 14px;
        color: #8b8795;
        letter-spacing: 0;
        margin-left: 7px;
        @media (max-width: $sm) {
          margin-left: 0;
        }
      }
    }
  }
  .downArrow {
    justify-self: flex-end;
    font-size: 20px;
    color: #000;
    margin-right: 25px;
    margin-left: 4px;
    height: 100%;
    display: flex;
    align-items: center;
    align-self: center;
    @media (max-width: $xl) {
      font-size: 1rem;
      color: #ffffff;
    }
    .fa-chevron-down {
      transform: rotate(0deg);
      transition-duration: 0.3s;
    }
    .fa-chevron-down.rotate {
      transform: rotate(180deg);
      transition-duration: 0.3s;
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: left;
    width: 100%;
  }
  .description-container {
    height: 0;
  }
  .description {
    height: 100%;
    font-family: "Brown-Regular";
    font-size: 14px;
    color: #000000;
    .bold {
    }
  }
  .description-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #ffffff;
    border: 3px solid #eeeeee;
    padding: 24px 20px;
    .description {
      max-width: 625px;
    }
    @media (max-width: $lg) {
      padding: 15px 25px 15px 25px;
    }
  }
}
.downArrow {
  justify-self: flex-end;
  font-size: 23px;
  color: #000 !important;
  margin-right: 25px;
  margin-left: 4px;
  height: 100%;
  display: flex;
  align-items: center;
  align-self: center;
  img {
    transform: rotate(0deg);
    transition-duration: 0.3s;
    @media (max-width: $lg) {
      height: 7px;
      width: 7px;
    }
  }
  img.rotate {
    transform: rotate(180deg);
    transition-duration: 0.3s;
  }
}
</style>
<style lang="scss">
.accordion-item {
  .description {
    span {
      color: red;
      &.bold {
        color: #000;
        font-family: "Brown-Bold";
      }
    }
    .link {
      color: #000;
      cursor: pointer;
      font-family: "Brown-Bold";
    }
  }
}
</style>